module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_guha_sm-b2afdd88208e8ba1d5636643e8e5f47e.png";